import moment from 'moment-timezone'
import _ from 'lodash'

export const unFormatTextWithUnderscore = string => {
  const string1 = string ? string.replace(/_/g, ' ') : ' '
  const captilizeFirstLetter = string1.replace(/\w\S*/g, function splitName(word) {
    return word.charAt(0) + word.slice(1).toLowerCase()
  })
  return captilizeFirstLetter
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export const sortData = (a, b) => {
  const letterA = a.label || a.name
  const letterB = b.label || b.name

  let comparison = 0
  if (letterA > letterB) {
    comparison = 1
  } else if (letterA < letterB) {
    comparison = -1
  }
  return comparison
}

export function dateRangeResetTheTime(evt) {
  if (evt !== null) {
    if (evt.length === 2) {
      if (evt[1].diff(evt[0], 'minute') === 0) {
        evt[0] = evt[0].startOf('day')
      }
      if (moment().diff(evt[1], 'day') < 0) {
        evt[1] = moment()
      }
    }
  }
}

export const toUKDateFormat = inputFormat => {
  const date = inputFormat.substring(8, 10)
  const month = inputFormat.substring(5, 7)
  const year = inputFormat.substring(0, 4)
  const ukDate = `${date}/${month}/${year}`
  return ukDate
}

export const formatDate = date => {
  const dateTime = date.replace('T', ' ').replace('Z', '')
  const formatedDateTime = dateTime.substring(0, dateTime.length - 1)

  return formatedDateTime
}

export const disabledFutureDate = current => {
  return current > moment().endOf('day')
}

export const formatToZoneDateOnly = (date, tz) => {
  const dateTime = moment(date)
  const formatedDateTime = dateTime.tz(tz).format('DD/MM/YYYY')
  return formatedDateTime
}

export const formatToZoneDate = (date, tz) => {
  const dateTime = moment(date)
  const formatedDateTime = dateTime.tz(tz).format('DD/MM/YYYY HH:mm:ss')
  return formatedDateTime
}

export const formatToZoneDateTZFormat = (date, tz) => {
  const dateTime = moment(date)
  const formatedDateTime = dateTime.tz(tz).format('YYYY-MM-DDTHH:mm:ss.SSSSZ')
  return formatedDateTime
}

export const formatToZoneTime = (date, tz) => {
  const dateTime = moment(date)
  const formatedHKTTime = dateTime.tz(tz).format('HH:mm:ss')
  return formatedHKTTime
}

export const formatChatLongTime = (date, tz) => {
  const dateTime = moment(date)
  const formatedHKTTime = dateTime.tz(tz).format('Do MMMM YYYY, h:mm:ss a')
  return formatedHKTTime
}

export const formatChatShortTime = (date, tz) => {
  const dateTime = moment(date)
  const formatedHKTTime = dateTime.tz(tz).format('h:mm A')
  return formatedHKTTime
}

export const parseQueryString = str => {
  const objURL = {}
  str.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), ($0, $1, $2, $3) => {
    objURL[$1] = $3
  })
  return objURL
}

export const amountFormatter = (amount, precision) => {
  precision = precision || 2
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: precision,
  })
  const numberFormatForDisplay = formatter.format(amount)
  return numberFormatForDisplay
}

export const updateObjInArray = (arr, obj) => {
  const newArr = arr.map(item => (item.id === obj.id ? obj : item))
  return newArr
}

export const getFormattedVendorOptions = options => {
  const newOptions = options.map(option => {
    return {
      id: option.id,
      value: option.id,
      title: option.tradingName,
      subtitle: option.registeredCompanyName,
    }
  })
  return newOptions
}

export const transformBeneKey = (key, beneFieldsList) => {
  const label = beneFieldsList.find(bene => bene.schemaName === key)
  return label === undefined ? '' : label.schemaName
}

export const capitalize = s => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const getLocalDepositAccountNames = accounts => {
  const names = []
  accounts.forEach(obj => {
    Object.entries(obj).forEach(([Key, value]) => {
      if (Key === 'nameOnAccount') {
        names.push(value)
      }
    })
  })
  return names
}

export const maskAccountNumber = accountNumber => {
  const char = '*'
  const maskAccountNum = accountNumber
    ? accountNumber.substring(0, 3) + char.repeat(4, 7) + accountNumber.substring(7, 9)
    : ''
  return maskAccountNum
}

export const transformCA = list => {
  list.map(item => {
    item.hide = true
    item.maskAccountNum = true
    return item
  })
  return list
}

export const transformBalTxn = list => {
  list.map(item => {
    item.amount =
      item.debitCredit === 'credit'
        ? `${`+`} ${amountFormatter(item.amount)}`
        : `${`-`} ${amountFormatter(item.amount)}`

    return item
  })
  return list
}

export const modifyCurrency = currencies => {
  const modifiedCurrency = []
  for (let i = 0; i < currencies.length; i += 1) {
    modifiedCurrency.push({
      id: currencies[i].id,
      title: currencies[i].name,
      value: currencies[i].code,
    })
  }
  return modifiedCurrency
}

export const cryptoAmountFormatter = (amount, precision) => {
  precision = precision || 4
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: precision,
  })
  const numberFormatForDisplay = formatter.format(amount)
  return numberFormatForDisplay
}

export const transformCryptoBalTxn = list => {
  list.map(item => {
    item.amount =
      item.direction === 'incoming'
        ? `${`+`} ${cryptoAmountFormatter(item.amount)}`
        : `${`-`} ${cryptoAmountFormatter(item.amount)}`

    return item
  })
  return list
}

export const flattenObject = obj => {
  const flattened = {}

  Object.keys(obj).forEach(key => {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      Object.assign(flattened, flattenObject(obj[key]))
    } else {
      flattened[key] = obj[key]
    }
  })

  return flattened
}

export const transformErrorData = errorData => {
  const errorDataList = []
  Object.entries(errorData).map(([, value]) => {
    return errorDataList.push(value[0])
  })
  return errorDataList
}

export const getAccountNumber = accountDetails => {
  let accountNumber
  if (accountDetails.isActiveAccountNumber) {
    if (accountDetails.iban) {
      accountNumber = accountDetails.iban
    } else {
      accountNumber = accountDetails.accountNumber
        ? accountDetails.accountNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        : '--'
    }
  } else {
    accountNumber = '--'
  }
  return accountNumber
}

// cc

export const validationCheckOnUploadDocuments = registerDetails => {
  const uploadedDocs =
    registerDetails.selectedDocumentFiles.length > 0 &&
    _.uniqBy(registerDetails.selectedDocumentFiles, 'documentType')
  const listOfAllDocs = registerDetails.uploadedDocumentsQuestions.documentsList
  let overAllUploadStatus = false
  if (
    uploadedDocs.length > 0 &&
    uploadedDocs.length === listOfAllDocs.length &&
    listOfAllDocs.length > 0
  ) {
    overAllUploadStatus = true
  } else {
    overAllUploadStatus = false
  }
  return overAllUploadStatus
}
